export const parameters = ({
    application: 'application',
    module: 'module',
    objectType: 'objectType',
    ownerId: 'ownerId',
    ownerType: 'ownerType',
    searchType: 'searchType',
    userId: 'userId',
});

export const values = ({
    userId: 'userId',
    comparisonSet: 'comparison_set',
});

export const endpoints = ({
    savedSearchList: 'Searches_MLS_Member',
    marketAreaList: 'Areas_filter',
    officeList: 'OfficeList_get',
    agentList: 'Agent_lists',
    mlsObjectList: 'MlsObjects_by_user',
});
